const DEMO_USERS: string[] = [
  "demo@acme.com",
  "english@mantrademo.com",
  "italian@mantrademo.com",
  "french@mantrademo.com",
  "spanish@mantrademo.com",
];

export function isDemoUser(emailAdress: string) {
  return DEMO_USERS.includes(emailAdress);
}
